import { render } from "./seasonActivityPage.vue?vue&type=template&id=f89b83a8&scoped=true"
import script from "./seasonActivityPage.vue?vue&type=script&lang=js"
export * from "./seasonActivityPage.vue?vue&type=script&lang=js"

import "./seasonActivityPage.vue?vue&type=style&index=0&id=f89b83a8&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89b83a8"]])

export default __exports__